import { Col } from 'reactstrap';
import { EmptyButton } from 'mol-ui';
import styled from 'styled-components';

export const AddressDetailsContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: center;
    margin: 0px 0px 20px 0px;
    width: 100%;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
    width: 100%;
`;

export const IconContainer = styled(EmptyButton)`

`;

export const ResponsiveCol = styled(Col)`
    @media(max-width: 575px) {
        align-items: center;
        display: flex;
        justify-content: center;
    }
`;

export const Text = styled.p`
    align-items: center;
    display: flex;
    color: ${ ({ theme: { secondaryColor } }) => secondaryColor };
    font-size: 15px;
    margin: 0px;
`;
